module.exports = __webpack_public_path__ + "app/img/microsoft.f0370e8b96.svg";